import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { DynamicForm, Card, Button, Icon, Spin, Link } from 'components/elements';
import Axios from 'axios';
import { BASE_URL } from '../../../inc/constants';
import { getAPIDefaultHeaders, handleCatch, handleUploadMedia, handleEntityDelete } from '../../../inc/functions';
import { Redirect } from 'react-router';

const ProductNew = ({ className, edit, match }) => {
  const [obj, setObj] = useState();
  const [categories, setCategories] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState();

  const handleSubmit = (data) => {
    setLoading(true);
    if (data.category_id) {
      data['category_id'] = parseInt(data.category_id);
    }
    if(edit){
      Axios.put(`${BASE_URL}/admin/products/${obj.id}/`, data, getAPIDefaultHeaders()).then((res) => {
        setRedirect(`/products/${res.data.id}/edit/`);
      }).catch((err) => {
        handleCatch(err);
        setLoading(false);
      });
    } else {
      Axios.post(`${BASE_URL}/admin/products/`, data, getAPIDefaultHeaders()).then((res) => {
        setRedirect(`/products/${res.data.id}/edit/`);
      }).catch((err) => {
        handleCatch(err);
        setLoading(false);
      });
    }
    
  };

  const loadCategories = () => {
    Axios.get(`${BASE_URL}/admin/categories/?parent__isnull=False&size=1000`, getAPIDefaultHeaders()).then((res) => {
      setCategories(res.data.results);
    }).catch((err) => {
      handleCatch(err);
    });
  };
  const loadObj = () => {
    const { id } = match.params;
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/products/${id}/`, getAPIDefaultHeaders()).then((res) => {
      setObj(res.data);
      setLoading(false);
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    });
  };

  useEffect(() => {
    const flds = [
      {
        type: 'text',
        name: 'name',
        label: 'عنوان محصول',
        required: true,
        value: obj?.name,
      },
      {
        type: 'text',
        name: 'name_fa',
        label: 'عنوان محصول (فارسی)',
        value: obj?.name_fa,
      },
      {
        type: 'text',
        name: 'slug',
        label: 'نام انگلیسی (slug)',
        value: obj?.slug,
        col: 2
      },
      {
        type: 'select',
        name: 'category_id',
        label: 'دسته‌بندی',
        value: obj?.category?.id,
        options: categories?.map((c) => ({ label: c.name, value: c.id })),
        col: 2,
      },
      {
        type: 'textarea',
        name: 'description',
        label: 'توضیحات',
        value: obj?.description,
      },
      {
        type: 'textarea',
        name: 'description_fa',
        label: 'توضیحات (فارسی)',
        value: obj?.description_fa,
      },
      {
        type: 'textarea',
        name: 'content',
        label: 'محتوای اصلی',
        value: obj?.content,
        required: true,
      },
      {
        type: 'textarea',
        name: 'content_fa',
        label: 'محتوای اصلی (فارسی)',
        value: obj?.content_fa,
      },
      {
        type: 'url',
        name: 'shop_url',
        label: 'لینک فروشگاه',
        placeholder: 'لینک محصول در فروشگاه را وارد نمایید.',
        value: obj?.shop_url,
        style: { direction: 'ltr', textAlign: 'left' },
      },
      {
        type: 'number',
        name: 'ordering',
        label: 'ترتیب',
		required: true,
		defaultValue: 1,
        value: obj?.ordering,
        placeholder: 'ترتیب بیشتر در لیست جایگاه بالاتری دارد.'
      },
      {
        type: 'image',
        name: 'primary_image_id',
        label: 'تصویر اصلی',
        value: obj?.primary_image,
      },
      {
        type: 'image',
        name: 'chart_id',
        label: 'تصویر چارت',
        value: obj?.chart,
      },
      {
        type: 'images',
        name: 'images_ids',
        label: 'تصاویر دیگر محصول',
        value: obj?.images,
        col: 1,
      },
	  {
        type: 'checkbox',
        name: 'is_active',
        label: 'فعال',
        value: obj?.is_active,
      },
    ];
    setFields(flds);
  }, [categories, obj]);
  
  useEffect(() => {
    loadCategories();
    if (edit) {
      loadObj();
    }
  }, []);

  const cardMeta = (
    <div style={{ textAlign: 'left'}}>
      {edit && <Button small error onClick={() => handleEntityDelete('products', obj.id, 'محصول', setLoading, () => setRedirect('/products/'))}>
        <Icon fa icon="trash" style={{marginLeft: 4}}/>
            حذف
        </Button>
      }
      <Link to="/products/">
        <Button small secondary>
          <Icon fa icon="angle-left" style={{marginLeft: 4}}/>
          بازگشت
        </Button>
      </Link>
    </div>
  );

  if (redirect) {
    return <Redirect to={redirect} />;
  }
  return (
    <Card title={edit ? 'ویرایش محصول' : 'محصول جدید'} meta={cardMeta}>
      <Spin active={loading}>
        <DynamicForm isEdit={edit} cols={2} fields={fields} onSubmit={handleSubmit} submitText="ذخیره" onUploadMedia={handleUploadMedia} />
      </Spin>
    </Card>
  );
};

const StyledProductNew = styled(ProductNew)`
    
`;

export default StyledProductNew;
